import React from 'react'
import Heading from '../shared/Heading'
import SellerCard from './SellerCard'
import { sellerMeals } from '../constants'
import { Link } from 'react-router-dom'

const Seller = () => {
    let data = {
        id: 1,
        price: 370,
        title: 'Krunch Burger',
        image: 'https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-krunch_variant_0-2023-05-31115706.png'
    }
  return (
    <div className='container mx-auto my-3'>
      <Link to={"/"}>
      <Heading data="BEST SELLERS" />
      </Link>
      <div className="flex gap-5 justify-between w-full mt-6 flex-wrap">
      {sellerMeals.map((item) => (
                    <div key={item.id} className='lg:w-[22%] sm:w-full md:w-[45%]'>
                        <SellerCard data={item}/>
                    </div>
                ))}
      </div>
    </div>
  )
}

export default Seller
